import { PendingPanelFooter, PendingPanelHeader } from 'components/secondaryMarket/shared/status/Panel';

import { FlexColumnPanel } from './FlexColumnPanel';

export function ProcessingSidePanel() {
  return (
    <FlexColumnPanel>
      <PendingPanelHeader />
      <PendingPanelFooter statusKey="secondaryMarket.sidePanel.label.awaitingConfirmation" />
    </FlexColumnPanel>
  );
}
